import * as actionTypes from "./actionTypes"
import Request from "../components/Request/Request";

const jwtDecode = require('jwt-decode');


export function loginSuccess(data) {
    return {
        type: actionTypes.LOGIN_SUCCESS,
        payload: data
    }
}

export function login(username, password) {
    return function (dispatch) {

        let url = "/emeklilik-app/api/auth/login";
        //url = "/api/auth/login";
            //    const request = new Request("/api/personel-calisma-detay/getListByTcKimlikNo/" + tcKimlikNo, "GET");
        let data = {username, password};
        const request = new Request(url, "POST", data);
        request.run()
            .then(response => {
                
                var data =response.data.data;
                let decoded = jwtDecode(data.token);

                

                localStorage.setItem('loggedIn', "true");
                localStorage.setItem('token', data.token);
                localStorage.setItem('username', data.username);
                localStorage.setItem('name', data.name);
                dispatch(loginSuccess({
                    loggedIn: true,
                    username: decoded.username,
                    name: decoded.name
                }));
            })
            .catch(error => {
                dispatch(loginSuccess({
                    loggedIn: false,
                    username: "",
                    name: ""
                }));
            });
    }
}


export function logout() {

    localStorage.setItem('loggedIn', "false");
    localStorage.setItem('token', "");
    localStorage.setItem('username', "");
    localStorage.setItem('name', "");
    return {
        type: actionTypes.LOGOUT_SUCCESS,
        payload: {
            loggedIn: false,
            username: "",
            name: ""
        }
    }
}
